import v01 from './01';
import v02 from './02';
import v03 from './03';

export default {
  v01,
  v02,
  v03,
};
